export default "__VITE_ASSET__f66c79cf__"